/* eslint-disable import/prefer-default-export */
import axios from 'axios'

const { SNOP_API } = process.env

const apiSnop = axios.create({
  baseURL: SNOP_API,
  withCredentials: true,
  timeout: 960000,
  headers: {
    'Content-Type': 'application/json',
  },
})


export { apiSnop }
